// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as React from "react";
import * as Data16 from "common/src/data/Data16.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as SupUnits from "./SupUnits.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as SupSection from "./SupSection.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function SupPowerups$UnlocksGroup(Props) {
  var units = Props.units;
  var skipPt = Props.skipPt;
  return React.createElement("div", {
              className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8" + (
                Caml_obj.caml_equal(skipPt, true) ? "" : " pt-20"
              )
            }, Belt_Array.map(units, (function (unitId) {
                    return React.createElement(SupUnits.UnitCard.make, {
                                unitId: unitId,
                                info: Dict.getExn(Data16.units, unitId),
                                key: unitId
                              });
                  })));
}

var UnlocksGroup = {
  make: SupPowerups$UnlocksGroup
};

function SupPowerups$God(Props) {
  var id = Props.id;
  var name = Props.name;
  var loot1 = Props.loot1;
  var loot2 = Props.loot2;
  var loot3 = Props.loot3;
  var fin = Props.fin;
  return React.createElement(ContentSection.make, {
              className: "md:w-[900px]",
              children: React.createElement("div", {
                    className: "flex flex-col sm:flex-row gap-8"
                  }, React.createElement("div", {
                        className: "w-[320px] md:w-[400px]"
                      }, React.createElement("h2", {
                            className: "text-2xl font-montserrat font-medium"
                          }, name), React.createElement("img", {
                            className: "flex-shrink-0 rounded w-[320px] md:w-[400px]",
                            height: "400",
                            src: "https://ap.tft.tools/img/new17/gods/" + Belt_Array.getExn(id.split("_"), 2).toLowerCase() + ".png?w=400",
                            width: "400"
                          })), React.createElement("div", {
                        className: "flex-1"
                      }, React.createElement("div", undefined, React.createElement("h3", {
                                className: "font-montserrat font-medium text-xl mb-1"
                              }, "Stage 2"), React.createElement("ul", {
                                className: "list-disc"
                              }, Belt_Array.map(loot1, (function (param) {
                                      return React.createElement("li", {
                                                  className: "ml-5 py-1"
                                                }, param[0], React.createElement(RitoDescription2.make, {
                                                      desc: param[1],
                                                      className: "leading-tight mt-1"
                                                    }));
                                    })))), React.createElement("div", undefined, React.createElement("h3", {
                                className: "font-montserrat font-medium text-xl mt-4 mb-1"
                              }, "Stage 3"), React.createElement("ul", {
                                className: "list-disc"
                              }, Belt_Array.map(loot2, (function (param) {
                                      return React.createElement("li", {
                                                  className: "ml-5 py-1"
                                                }, param[0], React.createElement(RitoDescription2.make, {
                                                      desc: param[1],
                                                      className: "leading-tight mt-1"
                                                    }));
                                    })))), React.createElement("div", undefined, React.createElement("h3", {
                                className: "font-montserrat font-medium text-xl mt-4 mb-1"
                              }, "Stage 4"), React.createElement("ul", {
                                className: "list-disc"
                              }, Belt_Array.map(loot3, (function (param) {
                                      return React.createElement("li", {
                                                  className: "ml-5 py-1"
                                                }, param[0], React.createElement(RitoDescription2.make, {
                                                      desc: param[1],
                                                      className: "leading-tight mt-1"
                                                    }));
                                    })))), React.createElement("div", undefined, React.createElement("h3", {
                                className: "font-montserrat font-medium text-xl mt-4"
                              }, "4-7 " + fin[0]), React.createElement(RitoDescription2.make, {
                                desc: fin[1],
                                className: "py-1 leading-tight"
                              }))))
            });
}

var God = {
  make: SupPowerups$God
};

function SupPowerups(Props) {
  var anomalies = Props.anomalies;
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  Sd.allUnits4(set);
  var basePath4 = CdnAtom.usePath4(undefined);
  return React.createElement(SupSection.make, {
              children: React.createElement("div", {
                    className: "grid grid-cols-3 gap-8"
                  }, Belt_Array.map(Belt_SortArray.stableSortBy(anomalies, (function (g1, g2) {
                              var w1 = Belt_Array.getExn(g1, 0);
                              var w2 = Belt_Array.getExn(g2, 0);
                              return (Caml.caml_int_compare(w1.cost, w2.cost) << 1) + Caml.caml_string_compare(w1.name, w2.name) | 0;
                            })), (function (group) {
                          var wisp = Belt_Array.getExn(group, 0);
                          return React.createElement(ContentSection.make, {
                                      className: "pt-3 pb-2",
                                      children: null
                                    }, React.createElement("div", {
                                          className: "flex items-center justify-between pb-2"
                                        }, React.createElement("div", {
                                              className: "font-montserrat font-medium"
                                            }, wisp.name), React.createElement("div", undefined, String(wisp.cost), React.createElement("img", {
                                                  className: "ml-[2px] pb-[1px] inline",
                                                  alt: "gold",
                                                  height: "13",
                                                  src: basePath4 + "/general/gold.png?w=13",
                                                  width: "13"
                                                }))), React.createElement("div", {
                                          className: "text-sm leading-tight"
                                        }, wisp.desc));
                        }))),
              id: "set-update-charms",
              title: t("Wisps")
            });
}

var make = SupPowerups;

export {
  UnlocksGroup ,
  God ,
  make ,
  
}
/* Sd Not a pure module */
